module.exports = __webpack_public_path__ + "static/media/twoImages.97651932.png";